import * as form from '../form';

export const substanceThcPublicSafety = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Description: form.textarea(xitem.Description),
        InvolvementDates: form.daterange(xitem.InvolvementDates),
        EstimatedUse: form.text(xitem.EstimatedUse),
        Comments: form.textarea(xitem.Comments),
        UseWhileEmployedPosition: form.text(xitem.UseWhileEmployedPosition),
        UseWhileEmployedPositionOther: form.textarea(xitem.UseWhileEmployedPositionOther),
        HowManyTimes: form.text(xitem.HowManyTimes),
        Reason: form.textarea(xitem.Reason),
      },
    };
  });
  return {
    UsedThc: form.branch(data.UsedThc),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
